import * as actionTypes from '../actionTypes/CompanyBalanceActionTypes';

const initialState = {
  // Balance Data
  balance: null,
  balanceLoading: false,
  balanceError: null,

  // Logs Data
  logs: [],
  logsLoading: false,
  logsError: null,
  pagination: {
    page: 1,
    limit: 50,
    offset: 0,
    total: 0,
    pages: 0,
  },

  // Filters
  filters: {
    limit: 50,
    offset: 0,
    type: null,
    startDate: null,
    endDate: null,
    sortBy: 'createdAt',
    sortOrder: 'DESC',
  },
};

const companyBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Company Balance
    case actionTypes.GET_COMPANY_BALANCE_REQUEST:
      return {
        ...state,
        balanceLoading: true,
        balanceError: null,
      };

    case actionTypes.GET_COMPANY_BALANCE_SUCCESS:
      return {
        ...state,
        balance: action.payload,
        balanceLoading: false,
        balanceError: null,
      };

    case actionTypes.GET_COMPANY_BALANCE_FAILURE:
      return {
        ...state,
        balanceLoading: false,
        balanceError: action.payload,
      };

    // Get Company Balance Logs
    case actionTypes.GET_COMPANY_BALANCE_LOGS_REQUEST:
      return {
        ...state,
        logsLoading: true,
        logsError: null,
      };

    case actionTypes.GET_COMPANY_BALANCE_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload || [],
        pagination: action.pagination || initialState.pagination,
        logsLoading: false,
        logsError: null,
      };

    case actionTypes.GET_COMPANY_BALANCE_LOGS_FAILURE:
      return {
        ...state,
        logsLoading: false,
        logsError: action.payload,
      };

    // Set Filters
    case actionTypes.SET_COMPANY_BALANCE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case actionTypes.CLEAR_COMPANY_BALANCE_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };

    // Clear Errors
    case actionTypes.CLEAR_COMPANY_BALANCE_ERRORS:
      return {
        ...state,
        balanceError: null,
        logsError: null,
      };

    // Loading States
    case actionTypes.SET_COMPANY_BALANCE_LOADING:
      return {
        ...state,
        balanceLoading: action.payload,
      };

    case actionTypes.SET_COMPANY_BALANCE_LOGS_LOADING:
      return {
        ...state,
        logsLoading: action.payload,
      };

    default:
      return state;
  }
};

export default companyBalanceReducer;
